module.exports = __webpack_public_path__ + "img/titlebar.264f38f0.jpeg";